module.exports = __webpack_public_path__ + "img/twitter-with-background.a719bc68.svg";